import type { CSSProperties } from 'react';
import { cn } from '../../lib/cn';

// A shimmering placeholder block. The shimmer keyframe lives in index.css (tinted by the selected theme) and is
// neutralized by the global prefers-reduced-motion rule (renders static then). It is rounded-md unless the caller
// passes its own rounded-* class, so avatars can be circles.
export default function Skeleton({ className, style }: { className?: string; style?: CSSProperties }) {
  return <div aria-hidden className={cn('skeleton', !/(^|\s)rounded/.test(className ?? '') && 'rounded-md', className)} style={style} />;
}
